// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:28.294Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:base': []
})(this, function (m_module, _) {

var M = m_module.M;

M.SKU = M.SKU || {};

M.SKU.MINI_CARDS_TYPE = ['HMC'];
M.SKU.MAGNET_PRODUCT_TYPES = ['SMG', 'BMG', 'SMF', 'GMG', 'GMF', 'BMF'];
M.SKU.CUSTOMIZABLE_WRAPPING_PAPER_TYPES = ['CWR'];
M.SKU.WRAPPING_PAPER_TYPES = ['CWR', 'NWR', 'MWR'];
M.SKU.ROOM_SIGN_TYPES = ['RDS'];
M.SKU.ORNAMENT_TYPES = ['HOC', 'HFO', 'HGO'];
M.SKU.PHOTO_BACKDROP_KINDS = ['PBD'];
// EC-14311 - We need to make a single standalone envelope (pk EGN) to look and
// perform like a letterpress LPI envelope. 
M.SKU.EURO_FLAP_STANDALONE_ENVELOPE_SKUS = ['MIN-PB9-EGN', 'MIN-PA2-EGN', 'MIN-PA3-EGN'];
M.SKU.BOOKLETTE_TYPES = ['HBK', 'GBK', 'BYK', 'WBK'];
M.SKU.TABLE_NUMBER_TYPES = ['TBL', 'TBF', 'TGN', 'LTR', 'PYT', 'FTN'];
M.SKU.NOTEBOOK_TYPES = ['NBK', 'MNB'];
M.SKU.WEDDING_PROGRAM_TYPES = ['WPR', 'WPF', 'WGP'];
M.SKU.MARKETPLACE_TYPES = [
	'MPI','MBP','MSI','MBI','MMC','MWM','MWS','MCS','MMS','MNA',
  'MBS','MTS','MOT','MCP','MGA','MKA', 'MWA','MGT','MHO','MFC','MWR',
  'MNB'];
M.SKU.BUSINESS_CARD_TYPES = ['BSC', 'BCF', 'MBC'];

// "STICKER_TYPES" should not include Party stickers like GSS.
M.SKU.STICKER_TYPES = ['CST', 'CNL', 'MST', 'MSL', 'NST', 'NSL', 'WST'];

// TODO: make this opaque
M.SKU.getProductKind = function(sku) {
  M.required(sku);
  return sku.split('-')[2];
};

M.SKU.isMagnetSku = function(sku) {
  return M.SKU.isMagnetKind(M.SKU.getProductKind(sku));
};

M.SKU.isOrnamentSku = function(sku) {
  return M.SKU.isOrnamentKind(M.SKU.getProductKind(sku));
};

M.SKU.isWrappingPaper = function(sku) {
  return M.SKU.isWrappingPaperKind(M.SKU.getProductKind(sku));
};

M.SKU.isPhotoBackdrop = function(sku) {
  return _.contains(M.SKU.PHOTO_BACKDROP_KINDS, M.SKU.getProductKind(sku));
};

M.SKU.isMiniCardKind = function(kind) {
  return _.contains(M.SKU.MINI_CARDS_TYPE, kind);
};

M.SKU.isMagnetKind = function(kind) {
  return _.contains(M.SKU.MAGNET_PRODUCT_TYPES, kind);
};

M.SKU.isWrappingPaperKind = function(kind) {
  return _.contains(M.SKU.WRAPPING_PAPER_TYPES, kind);
};

M.SKU.isCustomizableWrappingPaperKind = function(kind) {
  return _.contains(M.SKU.CUSTOMIZABLE_WRAPPING_PAPER_TYPES, kind);
};

M.SKU.isRoomSignKind = function(kind) {
  return _.contains(M.SKU.ROOM_SIGN_TYPES, kind);
};

M.SKU.isOrnamentKind = function(kind) {
  return _.contains(M.SKU.ORNAMENT_TYPES, kind);
};

M.SKU.isNotebook = function(sku) {
  var kind = M.SKU.getProductKind(sku);
  return _.contains(M.SKU.NOTEBOOK_TYPES, kind);
};

M.SKU.isUniqueWeddingProgram = function(sku) {
  return M.SKU.getProductKind(sku) == 'PDY';
};

M.SKU.isWeddingProgram = function(sku) {
  var kind = M.SKU.getProductKind(sku);
  return _.contains(M.SKU.WEDDING_PROGRAM_TYPES, kind);
};

M.SKU.isBusinessCard = function(sku) {
  var kind = M.SKU.getProductKind(sku);
  return _.contains(M.SKU.BUSINESS_CARD_TYPES, kind);
};

M.SKU.isEuroFlapEnvelope = function(sku) {
  return _.contains(M.Cu3.EURO_FLAP_STANDALONE_ENVELOPE_SKUS, sku);
};

M.SKU.isBooklette = function(sku) {
  var kind = M.SKU.getProductKind(sku);
  return _.contains(M.SKU.BOOKLETTE_TYPES, kind);
};

M.SKU.isCustomSticker = function(sku) {
  var kind = M.SKU.getProductKind(sku);
  return _.contains(M.SKU.STICKER_TYPES, kind);
};

M.SKU.isTableNumber = function(sku) {
  var kind = M.SKU.getProductKind(sku);
  return _.contains(M.SKU.TABLE_NUMBER_TYPES, kind);
};

M.SKU.isMarketplace = function(sku) {
  if (sku) {
    var kind = M.SKU.getProductKind(sku);
    return _.contains(M.SKU.MARKETPLACE_TYPES, kind);
  }
  return false;
};

return {
};

});
